export interface ProductOption {
  id: string;
  name: string;
}

/** Products to pick from: every list merged, one entry per product, sorted by name.
 *  Where a product is in more than one list the later list's name wins. */
export function productOptions(...lists: readonly ProductOption[][]): ProductOption[] {
  const byId = new Map<string, string>();
  for (const list of lists) {
    for (const p of list) byId.set(p.id, p.name);
  }
  return [...byId.entries()]
    .map(([id, name]) => ({ id, name }))
    .sort((a, b) => a.name.localeCompare(b.name));
}
